/**
 * Import Lib & assets
 */

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */

/**
 * styled components
 */

/**
 * cross component is..
 */

const Svg__cross = ({ style, color, size, onClick }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    style={style}
    onClick={onClick}
  >
    <path
      style={{ transform: `scale(${size / 19})` }}
      fillRule="evenodd"
      fill={color}
      d="M15.349.412L8.866 6.895 2.361.412.094 2.68l6.503 6.483-6.503 6.504 2.267 2.268 6.505-6.504 6.483 6.504 2.268-2.268-6.483-6.504 6.483-6.483L15.349.412z"
    />
  </svg>
);

export default Svg__cross;

Svg__cross.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Svg__cross.defaultProps = {
  style: {},
};

/*
    import Svg__cross from 'components/svg/cross/svg__cross'
    <Svg__cross />
  */
